// extracted by mini-css-extract-plugin
module.exports = {"project_section":"Projects_project_section__1Ua8V"};